import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import ErrorIcon from '@components/icons/StatusError.svg';
import PendingIcon from '@components/icons/StatusPending.svg';
import { ModalFooter } from '@modals/core-ui/ModalFooter';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useModalContext } from '@providers/ModalProvider';
import PositiveIcon from 'app/components/icons/Positive.svg';

type TProps = {
  onSuccess: () => void;
  title: string;
  message: string | React.ReactNode;
  buttonMessage?: string;
  status: 'pending' | 'success' | 'error';
  secondaryAction?: { label: string; onClick: () => void };
};

export const StatusModal = ({ onSuccess, message, title, buttonMessage = 'Ok', status, secondaryAction }: TProps) => {
  const { closeModal } = useModalContext();

  const onClick = () => {
    closeModal();
    onSuccess();
  };

  const onSecondaryClick = () => {
    closeModal();
    secondaryAction?.onClick();
  };

  const primaryButton = (
    <Button type="button" onClick={onClick}>
      {buttonMessage}
    </Button>
  );

  return (
    <ModalWrapper width="400px">
      <ModalTitle>{title}</ModalTitle>
      {status === 'success' && (
        <div className="mx-auto flex h-[60px] w-[60px] items-center justify-center">
          <PositiveIcon />
        </div>
      )}
      {status === 'pending' && (
        <div className="mx-auto flex h-[60px] w-[60px] items-center justify-center">
          <PendingIcon />
        </div>
      )}
      {status === 'error' && (
        <div className="mx-auto flex h-[60px] w-[60px] items-center justify-center">
          <ErrorIcon />
        </div>
      )}
      <p className="m-0 text-center">{message}</p>
      <ModalFooter>
        {secondaryAction ? (
          <OutlinedButton type="button" onClick={onSecondaryClick}>
            {secondaryAction.label}
          </OutlinedButton>
        ) : null}
        {primaryButton}
      </ModalFooter>
    </ModalWrapper>
  );
};
